<template>
    <div>
        <van-sticky>
            <div class="header">
                <div class="headerIcon">
                    <van-icon name="arrow-left" color="#fff" @click="returnIndexList" />
                </div>
            </div>
        </van-sticky>
        <div>
            <van-checkbox-group v-model="loadOption">
                <div class="
                      van-cell van-cell--clickable
                      van-dropdown-item__option
                    " v-for="(ele, index) in loadOptions" clickable :key="ele.id" :title="ele.name" role="button"
                    :tabindex="index">
                    <div class="van-cell__title">
                        <van-checkbox checked-color="#4f89ea" :name="ele.clientCard">
                            <div class="infoSource">
                                <span><span class="nameSex">姓名:</span>{{ ele.clientName }}</span>
                                <span><span class="nameSex">性别:</span>{{ ele.clientSex }}</span>
                            </div>
                            <div class="infoSource"><span class="nameSex">手机号:</span>{{ ele.clientMobile.replaceAll('，', '')
                            }}
                            </div>
                            <div class="infoSource"><span class="nameSex">卡号:</span>{{ ele.clientCard }}</div>
                            <!-- <div class="infoSource"><span class="nameSex">信息来源:</span>{{ ele.scName }}</div> -->
                        </van-checkbox>
                    </div>
                </div>
            </van-checkbox-group>
            <div class="textSure" @click="addposition()">
                <div class="selectSure">确定</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['loadOptions'],
    data() {
        return {
            loadOption: [],
        }
    },
    methods: {
        returnIndexList() {
            this.$emit('reBack');
        },
        addposition() {
            if (this.loadOption && this.loadOption != '') {
                let obj = {}
                // 提取数组中相同的元素
                let mobileArr = this.loadOptions.filter(item => this.loadOption.some(ele => ele === item.clientCard));
                // 多个电话号码数据处理 /拼接赋值.join('').replaceAll(' ', '/')
                let arr = (mobileArr.map((value) => value.clientMobile)).map(function (item) {
                    return item.replaceAll(' ', '/')
                })
                let mobileRes = arr.join('/')
                obj.clientMobile = mobileRes
                // 姓名处理
                let nameRes = mobileArr.map((value) => value.clientName).filter((num, index) => { return num !== '' }).join('/')
                obj.clientName = nameRes
                // 卡号处理
                let cardRes = mobileArr.map((value) => value.clientCard).filter((num, index) => { return num !== '' }).join('/')
                obj.clientCard = cardRes
                this.$emit('reBack', obj);
            } else {
                _g.toast("warning", '请选择客户信息');
            }
        },
    },
}
</script>
<style scoped>
.textSure {
    width: 100%;
    background: #fff;
    position: fixed;
    bottom: 0;
    left: 0;
}

.selectSure {
    width: 80%;
    margin: 0 auto;
    height: 2.875rem;
    background: linear-gradient(122deg, #17bcc5 0%, #0164a8 100%);
    border-radius: 5rem;
    text-align: center;
    line-height: 3rem;
    font-size: 0.9375rem;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    margin: 1rem 0 1rem 10%;
}

.headerIcon {
    width: 90%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    /* border: 1px solid red; */
}

.cardName {
    margin-bottom: 50px;
}

.infoSource {
    margin-bottom: 10px;
}

.nameSex {
    font-weight: bold;
    margin-bottom: 10px;
    margin-left: 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/page/info.vue